import React, {useContext} from 'react';
import {
    Container,
    makeStyles,
    Typography,
    Card,
    Grid,
    CardContent,
} from '@material-ui/core';
import Page from 'components/Page';
import { useTranslation } from "react-i18next";
import SecureFetchContext from "../../../context/SecureFetchContext";
import AppContext from "../../../context/AppContext";
import ConnectorPackagesBulk from "components/Connector/PackagesBulk";


const ConnectorPackageEditView = () => {
    const { t } = useTranslation();
    const secureFetch = useContext(SecureFetchContext);
    const { appValues } = useContext(AppContext);

    return (
        <Page
            title={t('navbar.connector_packages')}
        >
            <Container maxWidth={false}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <ConnectorPackagesBulk AppValues={appValues} secureFetch={secureFetch}/>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
};

export default ConnectorPackageEditView;